import { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as en from "../data/content";
import * as ar from "../data/content.ar";

const LangContext = createContext({ lang: "en", dir: "ltr", t: en, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("lc-lang") === "ar" ? "ar" : "en";
    } catch {
      return "en";
    }
  });

  const value = useMemo(() => {
    const isAr = lang === "ar";
    return { lang, dir: isAr ? "rtl" : "ltr", t: isAr ? { ...en, ...ar } : en, setLang };
  }, [lang]);

  useEffect(() => {
    const isAr = lang === "ar";
    document.documentElement.lang = isAr ? "ar" : "en";
    document.documentElement.dir = isAr ? "rtl" : "ltr";
    document.title = value.t.UI.docTitle;
    try {
      localStorage.setItem("lc-lang", lang);
    } catch {
      /* private mode */
    }
  }, [lang, value]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
